const SET_INCREMENT_PAGE = "SET_INCREMENT_PAGE";
const SET_DECREMENT_PAGE = "SET_DECREMENT_PAGE";
const SET_DEFAULT_PAGE = "SET_DEFAULT_PAGE";

const setIncrementPage = () => (dispatch) => {
  dispatch({
    type: SET_INCREMENT_PAGE,
  });
};

const setDecrementPage = () => (dispatch) => {
  dispatch({
    type: SET_DECREMENT_PAGE,
  });
};

const setDefaultPage = (value) => (dispatch) => {
  dispatch({
    type: SET_DEFAULT_PAGE,
    value,
  });
};

export { SET_INCREMENT_PAGE, SET_DECREMENT_PAGE, SET_DEFAULT_PAGE, setIncrementPage, setDecrementPage, setDefaultPage };
